<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>Assigned names and IP address info</h4>
        <button (click)="clear()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div *ngIf="historyService" class="modal-body modal-body--fixed-header">
        <div class="modal-body__fixed-header">
            <winde-tabs-nav
                    (tabChanged)="changeTab($event)"
                    *ngIf="tabsToShow && tabsToShow.length > 0"
                    [activeTab]="currentTab"
                    [customClass]="'tabs-nav--doc-tabs mb-1 report-tabs'"
                    [tabsList]="tabsToShow"
                    [translationPrefix]="'project.reportsTabs'"
            >
            </winde-tabs-nav>
        </div>
        <div #reportContainer class="modal-body__scroll-content">
            <form name="editForm">
                <ul *ngIf="nodesData?.length" class="nodes-data-list list-unstyled">
                    <li *ngFor="let node of nodesData; let nodeIndex = index">
                        <ng-container [ngModelGroup]="'nodeInfo' + nodeIndex">
                            <div class="d-inline-flex align-items-baseline mb-2">
                                <h6>Location name</h6>
                                <strong class="sector__node-name ml-4">
                                    <winde-node-pointer
                                            [listData]="{ nodeNames: node.nodeName, placement: 'top', cropName: 10 }"
                                    ></winde-node-pointer>
                                </strong>
                            </div>
                            <br/>

                            <table
                                    *ngIf="node.devicesData.length"
                                    aria-label="Node devices table"
                                    class="table table-striped table--links table-smaller-padding"
                            >
                                <thead>
                                    <tr>
                                        <th>Product type</th>
                                        <th>Assigned name</th>
                                        <th>IP address</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let device of node.devicesData; let deviceIndex = index">
                                        <ng-container [ngModelGroup]="'deviceInfo' + deviceIndex">
                                            <td class="deviceType">{{ device.typeName }}</td>
                                            <td class="deviceAN">
                                                <div
                                                        [ngClass]="{
                                                        'error-data-block': asName.errors?.error,
                                                        'warning-data-block': asName.errors?.warning
                                                    }"
                                                >
                                                    <input
                                                        #asName="ngModel"
                                                        [(ngModel)]="device.deviceAN"
                                                        [device]="device"
                                                        [locationName]="node.nodeName"
                                                        class="form-control-plaintext"
                                                        name="asName"
                                                        readonly
                                                        type="text"
                                                        windeAssignedNameViewValidator
                                                    />
                                                    <small *ngIf="asName.errors?.error">
                                                        {{ asName.errors?.error }}
                                                    </small>
                                                    <small *ngIf="asName.errors?.warning">
                                                        {{ asName.errors?.warning }}
                                                    </small>
                                                </div>
                                            </td>
                                            <td class="deviceIP">
                                                <div
                                                        [ngClass]="{
                                                        'error-data-block': ipAddr.errors?.error,
                                                        'warning-data-block': ipAddr.errors?.warning
                                                    }"
                                                >
                                                    <input
                                                        #ipAddr="ngModel"
                                                        [(ngModel)]="device.deviceIP"
                                                        [device]="device"
                                                        [hidden]="
                                                            device.deviceIP === IP_ZERO_VALUE || device.deviceIP === IP_OPTIONAL_VALUE
                                                        "
                                                        [locationName]="node.nodeName"
                                                        class="form-control-plaintext"
                                                        name="ipAddr"
                                                        readonly
                                                        type="text"
                                                        windeIpAddressViewValidator
                                                    />
                                                    <ng-container
                                                            *ngIf="
                                                            device.isSectorBu ||
                                                            device.ptP ||
                                                            !historyService.logicalTopology.exportLinksConfig.ipLessTu
                                                        "
                                                    >
                                                        <small *ngIf="ipAddr.errors?.error">
                                                            {{ ipAddr.errors?.error }}
                                                        </small>
                                                        <small *ngIf="ipAddr.errors?.warning">
                                                            {{ ipAddr.errors?.warning }}
                                                        </small>
                                                    </ng-container>
                                                </div>
                                            </td>
                                            <td>
                                                <ng-container
                                                        *ngIf="
                                                        asName.valid &&
                                                            (ipAddr.valid ||
                                                                (!device.isSectorBu &&
                                                                    !device.ptP &&
                                                                    historyService.logicalTopology.exportLinksConfig.ipLessTu));
                                                        else hasValidationIssues
                                                    "
                                                >
                                                    <button title="Device data valid" windeActionIcon>
                                                        <sui-svg-icon class="status-icon-success" icon="check-circle" windeGrey/>
                                                    </button>
                                                </ng-container>
                                                <ng-template #hasValidationIssues>
                                                    <ng-container
                                                            *ngIf="asName.errors?.error || ipAddr.errors?.error; then error; else warning"
                                                    >
                                                    </ng-container>
                                                    <ng-template #error>
                                                        <button title="Validation error" windeActionIcon>
                                                            <sui-svg-icon class="status-icon-error" icon="exclamation-circle" windeGrey/>
                                                        </button>
                                                    </ng-template>
                                                    <ng-template #warning>
                                                        <button title="Validation warning" windeActionIcon>
                                                            <sui-svg-icon
                                                                    class="status-icon-warning"
                                                                    icon="exclamation-triangle"
                                                                    windeGrey
                                                            />
                                                        </button>
                                                    </ng-template>
                                                </ng-template>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                    </li>
                </ul>
            </form>
        </div>
    </div>
</div>
